import React from 'react';
import mailcheck from 'mailcheck';

/** Takes an e-mail and returns either null or a suggested e-mail address */
export default function emailHinter(email) {
    /** In the future we can add some override to allow custom domains
     *  but for now we will stick with the defaults from mailcheck
     * 
     * We use this instead of mailcheck.run to avoid callback shenanigans
     */

    const suggestion = mailcheck.suggest(
        email,
        mailcheck.defaultDomains,
        mailcheck.defaultSecondLevelDomains,
        mailcheck.defaultTopLevelDomains,
        mailcheck.sift3Distance
    )

    return suggestion ? <em>Did you mean <strong>{suggestion.full}</strong>?</em> : null;
}